<template>
    <div class="content-wrapper">
        <section class="content-header">
            <h1>
                {{ $t('api.apis') }}

                <div class="pull-right">
                    <a
                        href="/apis/new"
                        class="btn btn-sm btn-primary"
                    >
                        <span class="sr-only">{{ $t('addNew') }}</span>
                        <span class="hidden-xs">{{ $t('addNew') }}</span>
                        <span class="visible-xs"><i class="fa fa-plus"></i></span>
                    </a>
                </div>
            </h1>
        </section>

        <section class="content">
            <Alerts />

            <div class="row">
                <div class="col-xs-12">

                    <ApisFilter />

                    <div class="box box-primary">
                        <div
                            v-if="!isLoaded"
                            class="box-body"
                        >
                            <img
                                class="table-row-preloader"
                                rel="preload"
                                src="/img/table-row-preloader.gif"
                            />
                        </div>

                        <div
                            v-show="isLoaded"
                            class="box-header with-border"
                        >
                            <h3 class="box-title">
                                {{ $t('api.apisTable') }}
                            </h3>
                            <div class="box-tools pull-right">
                                <button
                                    class="btn btn-box-tool"
                                    :title="$t('collapse')"
                                    type="button"
                                    @click="isCollapse = !isCollapse"
                                >
                                    <i
                                        class="fa"
                                        :class="{
                                            'fa-plus': !isCollapse,
                                            'fa-minus': isCollapse,
                                        }"
                                    />
                                </button>
                            </div>
                        </div>

                        <vue-slide-up-down
                            v-show="isLoaded"
                            :active="isCollapse"
                        >
                            <ApisTable @loaded="isLoaded = true" />
                        </vue-slide-up-down>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import ApisTable from '@/components/apis/ApisTable';
import ApisFilter from '@/components/apis/ApisFilter';

export default {
    components: {
        ApisTable,
        ApisFilter,
    },
    data() {
        return {
            isCollapse: true,
            isLoaded: false,
        };
    },
};
</script>
